import { useEffect, useState } from "react";

/**
 * @name useIsGooglebot
 * @description A hook to determine if the user agent is Googlebot.
 * This is useful for conditionally rendering content for SEO purposes,
 * for example, to avoid showing cookie banners or other overlays to the crawler.
 *
 * The check is performed on the client-side after hydration to avoid
 * mismatches between server-rendered and client-rendered content.
 * It defaults to `false` during server-side rendering.
 *
 * @returns {boolean} `true` if the user agent is identified as Googlebot, otherwise `false`.
 */
export const useIsGooglebot = (): boolean => {
  const [isGooglebot, setIsGooglebot] = useState(false);

  useEffect(() => {
    // This effect runs only on the client side, after the component has mounted.
    // This ensures that the initial render on the client matches the server render,
    // preventing hydration issues.
    const userAgent = window.navigator.userAgent;
    setIsGooglebot(/Googlebot/i.test(userAgent));
  }, []);

  return isGooglebot;
};
